var React = require('react');

function ArrowUpRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.86998 0L3.86639 1.53722L7.35871 1.54541L0 8.91193L1.08255 10L8.46143 2.61331L8.45315 6.15965L9.98565 6.16324L10 0.0143759L3.86998 0Z","fill":"black"}));
}

ArrowUpRight.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = ArrowUpRight;

ArrowUpRight.default = ArrowUpRight;
